import React, { useState } from 'react'
import {
  CommentBlock,
  FormButtonGroup,
  MessageWrapper,
  UploadWrapper,
  UploadFileListWrapper,
} from './ReplyMessageInternalStyled'
import { Input, Upload, Button, Form, message } from 'antd'
import { UploadOutlined, EditOutlined, HistoryOutlined } from '@ant-design/icons'
import moment from 'moment'
import { DATE_FORMAT_SLASH, HH_mm } from '../../constants'
import FileItem from '../Common/FileItemComponent/FileItem'
import utils from '../../utils'
import { inject, observer } from 'mobx-react'
import ContentBlockWrapper from '../ContentBlockWrapper'
import { systemName } from '../../config'
import UploadFileItem from '../Common/FileItemComponent/UploadFileItem'
import ReplyMessageEditModal from './ReplyMessageEditModal'
import InternalMessageHistoryModal from '../../pages/InternalMessage/InternalMessageHistoryModal'

const { TextArea } = Input
const ReplyMessageInternal = props => {
  const {
    fileStore,
    loadingAnimationStore,
    internalMessageStore,
    authenticationStore,
    internalMessageDetail,
    code,
    isReceive,
  } = props
  const { replyInternalMessages } = internalMessageStore
  const { currentUser } = authenticationStore

  const [form] = Form.useForm()
  const [fileList, setFileList] = useState([])
  const [editingComment, setEditingComment] = useState(null)
  const [historyCommentCode, setHistoryCommentCode] = useState(null)

  const handleChangeFile = info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const sendComment = async value => {
    const uploadFileList = fileList
      ? fileList.map(file => file.originFileObj)
      : []
    const batchUploadArr = []
    if ((isReceive && !code) || (isReceive && !internalMessageDetail.code)) {
      return message.warning('Không tìm thấy tin nhắn cần trả lời')
    }
    loadingAnimationStore.showSpinner(true)
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    let uploadedFiles = []
    try {
      const response = await Promise.all(batchUploadArr)
      uploadedFiles = response.map(response => response.data.file_id)
      const messageData = {
        content: value.content,
        file_ids: uploadedFiles,
        owner: currentUser?.userName || currentUser?.username,
        owner_name: currentUser?.fullName,
        parent_code: internalMessageDetail.code,
      }
      await internalMessageStore.create(messageData)
      if (isReceive) {
        await internalMessageStore.getReceiveMessageById(code)
      } else {
        await internalMessageStore.getSendMessageById(
          internalMessageDetail.code
        )
      }

      setFileList([])
      form.resetFields()
      message.success('Gửi phản hồi thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  return (
    <ContentBlockWrapper style={{ marginTop: 20 }}>
      {replyInternalMessages &&
        replyInternalMessages.length > 0 &&
        replyInternalMessages.map(msg => {
          const currentUsername =
            currentUser?.userName || currentUser?.username
          const isOwner = currentUsername && currentUsername === msg.owner

          return (
            <MessageWrapper key={msg.code}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 6,
                }}>
                <span className="title">{`${utils.getNameInCapitalize(
                  msg.owner_name
                )} - ${moment(msg.created_time).format(
                  DATE_FORMAT_SLASH
                )} - ${moment(msg.created_time).format(HH_mm)}`}</span>
                <div style={{ display: 'flex', gap: 4 }}>
                  <Button
                    type="link"
                    size="small"
                    icon={<HistoryOutlined />}
                    onClick={() => setHistoryCommentCode(msg.code)}>
                    Lịch sử
                  </Button>
                  {isOwner && (
                    <Button
                      type="link"
                      size="small"
                      icon={<EditOutlined />}
                      onClick={() => setEditingComment(msg)}>
                      Chỉnh sửa
                    </Button>
                  )}
                </div>
              </div>
              <p className="content" style={{ whiteSpace: 'pre-wrap' }}>
                {msg.content}
              </p>
              <div>
                {msg.file_ids?.length > 0 &&
                  msg.file_ids.map(file => (
                    <FileItem
                      key={file.file_id}
                      file_id={file.file_id}
                      file_name={file.name}
                      file_type={utils.getExtensionFile(file.name)}
                    />
                  ))}
              </div>
            </MessageWrapper>
          )
        })}
      <CommentBlock>
        <Form form={form} onFinish={sendComment}>
          <Form.Item name={'content'}>
            <TextArea rows={4} placeholder="Nội dung phản hồi" />
          </Form.Item>
          {fileList.length !== 0 && (
            <UploadFileListWrapper>
              {fileList.map(file => (
                <UploadFileItem
                  key={file.uid}
                  file_id={file.uid}
                  file_name={file.name}
                  file_type={utils.getExtensionFile(file.name)}
                  handleRemoveFileFromUploadList={() =>
                    handleRemoveFileFromUploadList(file.uid)
                  }
                />
              ))}
            </UploadFileListWrapper>
          )}
          <FormButtonGroup>
            <UploadWrapper>
              <Upload
                style={{ marginLeft: 4, marginRight: 4 }}
                valuePropName={'fileList'}
                fileList={fileList}
                multiple={true}
                onChange={handleChangeFile}
                beforeUpload={() => false}
                showUploadList={false}>
                <Button htmlType={'button'}>
                  <UploadOutlined /> Tải file
                </Button>
              </Upload>
            </UploadWrapper>
            <Button
              htmlType={'submit'}
              type={'primary'}
              style={{ padding: '4px 20px' }}>
              Gửi phản hồi
            </Button>
          </FormButtonGroup>
        </Form>
      </CommentBlock>

      <ReplyMessageEditModal
        isVisible={Boolean(editingComment)}
        comment={editingComment}
        handleCancel={() => setEditingComment(null)}
        isReceive={isReceive}
        parentCode={internalMessageDetail?.code || code}
      />

      <InternalMessageHistoryModal
        code={historyCommentCode}
        isVisible={Boolean(historyCommentCode)}
        handleCloseHistory={() => setHistoryCommentCode(null)}
        title="Lịch sử chỉnh sửa phản hồi"
      />
    </ContentBlockWrapper>
  )
}

ReplyMessageInternal.propTypes = {}

export default inject(
  'fileStore',
  'loadingAnimationStore',
  'internalMessageStore',
  'authenticationStore'
)(observer(ReplyMessageInternal))
